// extracted by mini-css-extract-plugin
module.exports = {"label":"Label-module__label___2_4C0"};